<div class="card mb-4" *ngIf="!isPdf">
  <div class="card-body">
    <div class="d-flex gap-4">
      <i class="bi bi-file-earmark-word fs-2"></i>
      <div class="flex-fill">
        <h5 class="card-title">Download</h5>
        <p>
          <small class="text-secondary">Download a copy of this document to your computer</small>
        </p>

        <button type="button" class="btn btn-primary" (click)="onDownloadClicked(false)">Download</button>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body">
    <div class="d-flex gap-4">
      <i class="bi bi-file-earmark-pdf fs-2"></i>
      <div class="flex-fill">
        <h5 class="card-title">Download as PDF</h5>
        <p>
          <small class="text-secondary">Download a copy of this document to your computer as a PDF file</small>
        </p>

        <button type="button" class="btn btn-primary" (click)="onDownloadClicked(true)">Download as PDF</button>
      </div>
    </div>
  </div>
</div>
